(function () {
  'use strict';

  var root = document.querySelector('[data-free-shipping]');
  if (!root) return;

  var threshold = parseInt(root.dataset.threshold, 10) || 0;
  var tmplBelow = root.dataset.msgBelow || '';
  var tmplDone  = root.dataset.msgDone  || '';
  var msgEl  = root.querySelector('[data-fsp-msg]');
  var fillEl = root.querySelector('[data-fsp-fill]');

  var cs      = document.querySelector('[data-cross-sell]');
  var csList  = cs ? cs.querySelector('[data-cross-sell-list]') : null;
  var csTmpl  = cs ? cs.querySelector('[data-cross-sell-template]') : null;
  var csCount = cs ? (parseInt(cs.dataset.count, 10) || 4) : 0;
  var csApi   = cs ? cs.dataset.apiUrl : '';

  // 送料判定はベース価格 (cart.original_total_price)。
  // 理由: cart-template.liquid 内ルール「クーポンは送料には適用されません。
  //       送料無料アイテムの商品金額が3,990円を下回りますと送料は加算となります」
  function readCurrentYen() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var cents = (c.original_total_price != null) ? c.original_total_price : c.total_price;
        return Math.floor((cents || 0) / 100);
      })
      .catch(function () {
        var fallback = parseInt(root.dataset.currentYen, 10);
        return isNaN(fallback) ? 0 : fallback;
      });
  }

  function readCartHandles() {
    var nodes = document.querySelectorAll('[data-cart-item]');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var url = nodes[i].getAttribute('data-cart-item-url') || '';
      var handle = url.split('?')[0].replace('/products/', '');
      if (handle) out.push(handle);
    }
    return out;
  }

  function formatYen(n) {
    return Number(n).toLocaleString('ja-JP');
  }

  function render() {
    return readCurrentYen().then(function (cur) {
      var diff = Math.max(0, threshold - cur);
      var done = diff === 0;
      var tmpl = done ? tmplDone : tmplBelow;
      if (msgEl) msgEl.textContent = tmpl.replace('{{amount}}', formatYen(diff));
      if (fillEl) {
        var pct = threshold > 0 ? Math.min(100, (cur / threshold) * 100) : 100;
        fillEl.style.width = pct + '%';
      }
      return renderCrossSell(diff);
    });
  }

  function renderCrossSell(diff) {
    if (!cs || !csApi || !csList || !csTmpl) return;
    if (diff <= 0) { cs.hidden = true; return; }
    var exclude = readCartHandles();
    var url = csApi + '?min_price=' + encodeURIComponent(diff) + '&limit=' + encodeURIComponent(csCount);
    if (exclude.length) {
      url += '&exclude=' + encodeURIComponent(exclude.join(','));
    }
    return fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (products) {
        if (!Array.isArray(products) || products.length === 0) {
          cs.hidden = true;
          return;
        }
        csList.innerHTML = '';
        products.forEach(function (p) {
          var node = csTmpl.content.cloneNode(true);
          var link = node.querySelector('[data-cs-link]');
          var img  = node.querySelector('[data-cs-image]');
          var t    = node.querySelector('[data-cs-title]');
          var pr   = node.querySelector('[data-cs-price]');
          if (link) link.href = p.product_url || ('/products/' + p.handle);
          if (img && p.featured_image_url) img.src = p.featured_image_url;
          if (t) t.textContent = p.title || '';
          if (pr) pr.textContent = '¥' + formatYen(p.price || 0);
          csList.appendChild(node);
        });
        cs.hidden = false;
      })
      .catch(function () { cs.hidden = true; });
  }

  document.addEventListener('cart:updated', render);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
